import html from "./SurveyList.html"
import "./SurveyList.css"
import { loadTasks } from '../../../api/participant/tasks';

var module = angular.module("ResearchKitApplicationModule");

module.component('surveyList', {
	template: html,
	bindings: {
		listTitle: '<',
		patientId: '='
	},
	controller: 'surveyListController',
	controllerAs: 'vm'
});

module.controller("surveyListController", ["$scope",
	function ($scope) {
		var vm = this;

		function loadSurveys() {
			loadTasks(vm.patientId).then(function (result) {
				$scope.$apply(function () {
					vm.surveyCategories = result;
					if (vm.surveyCategories.length === 0) {
						vm.noSurveys = true;
					}
				});
			}).finally(function () {
				$scope.$apply(function () {
					vm.loadingSurveys = false;
				});
			});
		}

		vm.startSurvey = function (survey) {
			if (survey.CompletionStatus == 'Completed' || survey.Blocked) { return; }

			if (survey.ValidPlatforms && survey.ValidPlatforms.indexOf("Web") == -1) {
				alert("This project is not available on the web.  Please use your mobile device to complete this survey.");
			} else {
				vm.currentSurvey = { taskID: survey.TaskID };
			}
		}

		$scope.$on('refreshDashboard', function (event, taskResult) {
			loadSurveys();
		});

		$scope.$on('surveyFinished', function (event, reason, taskResult) {
			function resetState() {
				loadSurveys();
				vm.currentSurvey = undefined;
			}

			if (taskResult) {
				for (var i = 0; i < vm.surveyCategories.length; i++) {
					var task = _.find(vm.surveyCategories[i].Tasks, function (task) { return task.TaskID == taskResult.TaskID; });
					if (task) {
						task.CompletionStatus = 'Completed';
					}
				}
			}
			resetState();
		});

		vm.loadingSurveys = true;
		vm.$onInit = function () {
			loadSurveys();
		}
	}
]);